const createSlot = () => {
  const slot = [];
  return {
    set: (data) => {
      slot.length = 0;
      slot.push(data);
    },
    get: () => (slot.length > 0 ? slot : []),
    clear: () => {
      slot.length = 0;
    },
  };
};

const region = createSlot();
const country = createSlot();
const level = createSlot();

export const addOneRegion = region.set;
export const getOneRegion = region.get;
export const cleanOneRegion = region.clear;

export const addOneCountry = country.set;
export const getOneCountry = country.get;
export const cleanOneCountry = country.clear;

export const addOneLevel = level.set;
export const getOneLevel = level.get;
export const cleanOneLevel = level.clear;

export const clearBreadCumb = () => {
  region.clear();
  country.clear();
  level.clear();
};

export const resetBreadCumb = clearBreadCumb;
